import { useStorage } from './use-storage';

/**
 *
 * @param key - The key to store the value in local storage. If undefined, the value will be stored in the state only.
 * @param initialValue
 * @param shouldDispatchEvents - Whether to dispatch a storage event when the value is changed.
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useLocalStorage = <T>(key: string | undefined, initialValue?: T) => {
	return useStorage<T>('localStorage', key, initialValue);
};
